module.exports = __webpack_public_path__ + "img/menu_logo.43abf401.png";